module.exports = __webpack_public_path__ + "static/img/11.13388a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/11.png
// module id = XV5J
// module chunks = 0